module.exports = __webpack_public_path__ + "img/selfie.4c431500.png";